export default "__VITE_ASSET__bdda7e92__"